import {
  START_SESSION_SUCCESS,
  START_SESSION_FAIL,
  CHEATING_ATTEMPT_RESPONSE,
  CHEATING_ATTEMPT_FAIL,
  SET_BLACKLIST_STATUS,
  BLACKLIST_STATUS_FAIL
} from "../Actions/types";

const initialState = {
  sessionStarted: false,
  attemptResponse: null,
  isBlacklisted: false,
  error: null,
};

export default function placementSecurityReducer(state = initialState, action) {
  switch (action.type) {
    case START_SESSION_SUCCESS:
      return { ...state, sessionStarted: true, error: null };
    case START_SESSION_FAIL:
      return { ...state, sessionStarted: false, error: action.payload };

    case CHEATING_ATTEMPT_RESPONSE:
      return { ...state, attemptResponse: action.payload, error: null };
    case CHEATING_ATTEMPT_FAIL:
      return { ...state, attemptResponse: null, error: action.payload };

    case SET_BLACKLIST_STATUS:
      return { ...state, isBlacklisted: action.payload, error: null };
    case BLACKLIST_STATUS_FAIL:
      return { ...state, isBlacklisted: false, error: action.payload };

    default:
      return state;
  }
}
